<template>
    <div class="totalPadding">
        <div class="topline">
            <h1><span>Produkter</span></h1>
            <div class="searching">
                <form action="/products/search" method="get">
                    <input type="text" name="q" placeholder="Søg efter produkt">
                    <button>
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </button>
                </form>
            </div>
        </div>
        <v-layout row wrap justify-center class="product-categories">
            <v-flex xs12 sm6 md3 v-for="item in categories" key="item.id">
                <router-link :to="{ name: 'category', params: { category: item.url }}">
                    <div class="cBox">
                        <img class="ikon" :src="'/img/categories/' + item.code + '.png'" />
                        <span>{{item.name}}</span>
                        <img class="produktvis" :src="'/img/categories/' + item.code + 'thumb.jpg'" />
                        <div class="selectThis">
                            Vælg kategori
                        </div> 
                    </div>
                </router-link>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    export default {
        data: () => ({
            categories: []
        }),
        components: {},
        computed: {

        },
        methods: {

        },
        created() {
            this.$http("/api/categories").then(x => {
                this.categories = x.data;
            });
        },
        mounted() {

        }
    }
</script>

<style scoped>

    .product-categories {

    }

    @media (min-width: 1600px) {
        .product-categories > .flex {
            -webkit-box-flex: 1;
            -ms-flex: 1 1 0px;
            flex: 1 1 0px;
        }

    }


</style>
